import { render, staticRenderFns } from "./addBilling.vue?vue&type=template&id=0fbe5d60&"
import script from "./addBilling.vue?vue&type=script&lang=ts&"
export * from "./addBilling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports